/* Dropline theme JS: no dependencies */
(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const T = window.theme || { routes: {}, cartType: 'drawer', currency: 'USD' };
  const body = document.body;
  let lastFocus = null;

  /* ---------- Drawers ---------- */
  function openDrawer(id) {
    const drawer = document.getElementById(id);
    if (!drawer) return;
    closeDrawers(true);
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    body.classList.add('has-drawer');
    setTimeout(() => {
      const target = drawer.querySelector('input:not([type=hidden]), select, button, a[href]');
      if (target) target.focus({ preventScroll: true });
    }, 60);
  }

  function closeDrawers(silent) {
    $$('.drawer.is-open').forEach((d) => {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    body.classList.remove('has-drawer');
    if (!silent && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawers();
    if (e.key === 'Tab') {
      const open = $('.drawer.is-open');
      if (!open) return;
      const items = $$('a[href], button:not([disabled]), input:not([type=hidden]):not([disabled]), select, textarea', open)
        .filter((el) => el.offsetParent !== null);
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Cart helpers ---------- */
  const rootUrl = T.routes.root || '/';

  async function refreshCart() {
    const res = await fetch(`${rootUrl}?sections=cart-drawer`, { headers: { Accept: 'application/json' } });
    const json = await res.json();
    const doc = new DOMParser().parseFromString(json['cart-drawer'], 'text/html');
    const next = doc.getElementById('cart-drawer');
    const current = document.getElementById('cart-drawer');
    if (!next || !current) return;
    current.innerHTML = next.innerHTML;
    current.dataset.itemCount = next.dataset.itemCount;
    $$('[data-cart-count]').forEach((el) => { el.textContent = next.dataset.itemCount; });
  }

  async function changeLine(line, quantity) {
    await fetch(T.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity })
    });
    await refreshCart();
  }

  function showError(form, message) {
    let el = $('[data-form-error]', form);
    if (!el) {
      el = document.createElement('p');
      el.className = 'form-error';
      el.setAttribute('role', 'alert');
      el.setAttribute('data-form-error', '');
      form.appendChild(el);
    }
    el.textContent = message;
    el.hidden = false;
    clearTimeout(el._t);
    el._t = setTimeout(() => { el.hidden = true; }, 5000);
  }

  /* ---------- Add to cart (AJAX) ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();

    const data = new FormData(form);
    if (e.submitter && e.submitter.name) data.set(e.submitter.name, e.submitter.value);
    if (!data.get('id')) return;

    const btn = e.submitter && e.submitter.classList.contains('btn') ? e.submitter : $('[data-add-btn]', form);
    if (btn) btn.classList.add('is-loading');

    try {
      const res = await fetch(T.routes.cartAdd, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: data
      });
      const json = await res.json();
      if (!res.ok || json.status) {
        showError(form, json.description || json.message || 'Could not add to cart.');
        return;
      }
      if (T.cartType === 'page') {
        window.location.href = T.routes.cart;
        return;
      }
      await refreshCart();
      openDrawer('cart-drawer');
    } catch (err) {
      showError(form, 'Something went wrong. Please try again.');
    } finally {
      if (btn) btn.classList.remove('is-loading');
    }
  });

  /* ---------- Click delegation ---------- */
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      if (opener.dataset.open === 'cart-drawer' && T.cartType === 'page') return;
      e.preventDefault();
      openDrawer(opener.dataset.open);
      return;
    }

    if (e.target.closest('[data-close]')) {
      e.preventDefault();
      closeDrawers();
      return;
    }

    const qtyBtn = e.target.closest('button[data-qty]');
    if (qtyBtn) {
      const line = qtyBtn.closest('[data-line]');
      if (!line) return;
      const next = Math.max(0, Number(line.dataset.qty) + Number(qtyBtn.dataset.qty));
      qtyBtn.disabled = true;
      changeLine(line.dataset.line, next);
      return;
    }

    const remove = e.target.closest('[data-remove]');
    if (remove) {
      const line = remove.closest('[data-line]');
      if (line) changeLine(line.dataset.line, 0);
      return;
    }

    const step = e.target.closest('[data-qty-step]');
    if (step) {
      const input = $('[data-qty-input]', step.closest('form'));
      if (input) input.value = Math.max(1, (Number(input.value) || 1) + Number(step.dataset.qtyStep));
    }
  });

  /* ---------- Live date & time ---------- */
  let clockTimer = null;
  function initClock() {
    const els = $$('[data-clock]');
    if (!els.length) return;
    const format = (tz, label) => {
      try {
        const parts = new Intl.DateTimeFormat('en-GB', {
          day: 'numeric', month: 'short', year: 'numeric',
          hour: '2-digit', minute: '2-digit', hour12: false,
          timeZone: tz || undefined
        }).formatToParts(new Date());
        const get = (type) => (parts.find((p) => p.type === type) || {}).value || '';
        let hour = get('hour');
        if (hour === '24') hour = '00';
        return `${get('day')} ${get('month')} ${get('year')}, ${hour}:${get('minute')}${label ? ' ' + label : ''}`;
      } catch (err) {
        return '';
      }
    };
    const tick = () => els.forEach((el) => { el.textContent = format(el.dataset.tz, el.dataset.label); });
    tick();
    clearInterval(clockTimer);
    clockTimer = setInterval(tick, 15000);
  }

  /* ---------- Product gallery carousel ---------- */
  function initGallery(root) {
    const track = $('[data-gallery-track]', root);
    if (!track) return null;
    const slides = $$('[data-gallery-slide]', track);
    const dots = $$('[data-gallery-dot]', root);
    if (slides.length < 2) return null;

    function activate(i) {
      dots.forEach((d, di) => d.classList.toggle('is-active', di === i));
    }

    function goTo(i) {
      const idx = Math.max(0, Math.min(slides.length - 1, i));
      slides[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }

    function currentIndex() {
      const trackRect = track.getBoundingClientRect();
      let closest = 0;
      let best = Infinity;
      slides.forEach((s, i) => {
        const d = Math.abs(s.getBoundingClientRect().left - trackRect.left);
        if (d < best) { best = d; closest = i; }
      });
      return closest;
    }

    let ticking = false;
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { activate(currentIndex()); ticking = false; });
    }, { passive: true });

    const prevBtn = $('[data-gallery-prev]', root);
    const nextBtn = $('[data-gallery-next]', root);
    if (prevBtn) prevBtn.addEventListener('click', () => goTo(currentIndex() - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(currentIndex() + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));

    return {
      goToMedia(mediaId) {
        const idx = slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
        if (idx > -1) { goTo(idx); activate(idx); }
      }
    };
  }

  /* ---------- Product variants ---------- */
  function initProduct(root) {
    const gallery = initGallery(root);
    const dataEl = $('[data-variants]', root);
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const idInput = $('[data-variant-id]', root);
    const addBtn = $('[data-add-btn]', root);
    const priceEl = $('[data-price]', root);
    const money = new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: T.currency });
    const fmt = (cents) => money.format(cents / 100);

    function selected() {
      return $$('.opt', root).map((fs) => {
        const checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
    }

    function update() {
      const picks = selected();
      $$('.opt', root).forEach((fs, i) => {
        const label = $('[data-option-value]', fs);
        if (label && picks[i]) label.textContent = picks[i];
      });

      const variant = variants.find((v) => v.options.every((o, i) => o === picks[i]));
      if (!variant) {
        addBtn.disabled = true;
        addBtn.textContent = 'Unavailable';
        return;
      }

      idInput.value = variant.id;
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';

      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      priceEl.innerHTML = onSale
        ? `<span class="price price--sale"><s class="price__compare">${fmt(variant.compare_at_price)}</s> <span class="price__now">${fmt(variant.price)}</span></span>`
        : `<span class="price"><span class="price__now">${fmt(variant.price)}</span></span>`;

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      if (variant.featured_media && gallery) {
        gallery.goToMedia(variant.featured_media.id);
      }
    }

    $$('[data-options]', root).forEach((el) => el.addEventListener('change', update));
  }

  /* ---------- Related products ---------- */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(async (el) => {
      if (!el.dataset.url || el.children.length) return;
      try {
        const res = await fetch(el.dataset.url);
        if (!res.ok) return;
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const incoming = $('[data-recommendations]', doc);
        if (incoming && incoming.innerHTML.trim()) el.innerHTML = incoming.innerHTML;
      } catch (err) { /* recommendations are optional */ }
    });
  }

  /* ---------- Music player ---------- */
  const PLAYER_KEY = 'dropline-player';
  let playerApi = null;

  function initPlayer(root) {
    const dataEl = $('[data-tracks]', root);
    if (!dataEl) return;
    let tracks = [];
    try { tracks = JSON.parse(dataEl.textContent); } catch (err) { tracks = []; }
    if (!tracks.length) { root.hidden = true; return; }
    root.hidden = false;

    const audio = $('[data-audio]', root);
    const toggleBtn = $('[data-toggle]', root);
    const muteBtn = $('[data-mute]', root);
    let state = {};
    try { state = JSON.parse(sessionStorage.getItem(PLAYER_KEY) || '{}'); } catch (err) { state = {}; }

    let index = Math.min(Math.max(Number(state.i) || 0, 0), tracks.length - 1);
    let wantPlay = !!state.want;

    audio.volume = Math.min(1, Math.max(0, (Number(root.dataset.volume) || 60) / 100));
    audio.muted = !!state.muted;
    root.classList.toggle('is-muted', audio.muted);

    const save = () => {
      try {
        sessionStorage.setItem(PLAYER_KEY, JSON.stringify({ i: index, t: audio.currentTime || 0, want: wantPlay, muted: audio.muted }));
      } catch (err) { /* ignore */ }
    };

    function load(i, resumeAt) {
      index = (i + tracks.length) % tracks.length;
      const track = tracks[index];
      audio.src = track.src;
      $('[data-title]', root).textContent = track.title || '';
      $('[data-artist]', root).textContent = track.artist || '';
      $('[data-cover]', root).style.backgroundImage = track.cover ? `url("${track.cover}")` : '';
      if (resumeAt) {
        audio.addEventListener('loadedmetadata', () => {
          try { audio.currentTime = resumeAt; } catch (err) { /* ignore */ }
        }, { once: true });
      }
      save();
    }

    function play() {
      const attempt = audio.play();
      if (attempt && attempt.catch) attempt.catch(() => { root.classList.remove('is-playing'); });
    }

    audio.addEventListener('play', () => {
      root.classList.add('is-playing');
      toggleBtn.setAttribute('aria-label', 'Pause');
    });
    audio.addEventListener('pause', () => {
      root.classList.remove('is-playing');
      toggleBtn.setAttribute('aria-label', 'Play');
    });
    audio.addEventListener('ended', () => { load(index + 1); wantPlay = true; play(); });

    toggleBtn.addEventListener('click', () => {
      if (audio.paused) { wantPlay = true; play(); } else { wantPlay = false; audio.pause(); }
      save();
    });
    $('[data-next]', root).addEventListener('click', () => { load(index + 1); wantPlay = true; play(); });
    $('[data-prev]', root).addEventListener('click', () => {
      if (audio.currentTime > 4) { audio.currentTime = 0; } else { load(index - 1); }
      wantPlay = true;
      play();
    });
    muteBtn.addEventListener('click', () => {
      audio.muted = !audio.muted;
      root.classList.toggle('is-muted', audio.muted);
      muteBtn.setAttribute('aria-label', audio.muted ? 'Unmute' : 'Mute');
      save();
    });

    load(index, Number(state.t) || 0);
    if (wantPlay) play(); // may be blocked by the browser until the visitor taps something

    setInterval(() => { if (!audio.paused) save(); }, 1000);
    window.addEventListener('pagehide', save);

    playerApi = {
      autoplay: root.dataset.autoplay === 'true',
      start: () => { wantPlay = true; play(); save(); },
      isActive: () => wantPlay
    };
  }

  // The visitor clicked ENTER: that tap lets the browser start the music.
  document.addEventListener('dropline:enter', () => {
    if (playerApi && playerApi.autoplay && !playerApi.isActive()) playerApi.start();
  });

  /* ---------- Init ---------- */
  function initAll() {
    initClock();
    $$('[data-product]').forEach(initProduct);
    initRecommendations();
    $$('[data-player]').forEach(initPlayer);
  }
  initAll();

  // Theme editor: re-run when a section is re-rendered
  document.addEventListener('shopify:section:load', (e) => {
    initClock();
    $$('[data-product]', e.target).forEach(initProduct);
    initRecommendations();
    $$('[data-player]', e.target).forEach(initPlayer);
  });
})();
